/** @format */

import React, { useEffect, useState } from "react";
import NavbarCustom from "../../Components/Layout/Navbar/NavbarCustom";
import Footer from "../../Components/Layout/Footer/Index";
import Image from "../../Constants/Image";
import { colors } from "../../Constants/theme";
import SponsorsTable from "../../Components/Layout/SponsorsTable/Index";
import axios from "axios";
import { useGetAll } from "../../Hooks/useGetAll";

const Index = () => {
  const [currentSponsors, setCurrentSponsors] = useState([]);
  const [oldSponsors, setOldSponsors] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(100);
  const [oldLimit, setOldLimit] = useState(100);
  const [oldPaginationModel, setOldPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const fetchLimits = async () => {
    try {
      const currentRes = await axios.get(
        `${process.env.REACT_APP_FE_URL}records/sponsors/current/nt/`
      );
      setCurrentLimit(currentRes?.data.total_count || 100);

      const oldRes = await axios.get(
        `${process.env.REACT_APP_FE_URL}records/sponsors/old/nt/`
      );
      setOldLimit(oldRes?.data.total_count || 100);
    } catch (error) {
      console.error("Error fetching limits:", error);
    }
  };

  useGetAll({
    key: `/records/sponsors/current/nt/?limit=${currentLimit}`,
    select: (data) => data?.data?.rows,
    onSuccess: (data) => {
      setCurrentSponsors(data);
    },
  });

  useGetAll({
    key: `/records/sponsors/old/nt/?limit=${
      oldPaginationModel.pageSize
    }&page=${oldPaginationModel.page + 1}`,
    select: (data) => data?.data?.rows,
    onSuccess: (data) => {
      setOldSponsors(data);
    },
  });

  useEffect(() => {
    fetchLimits();
  }, []);

  return (
    <div>
      <title>Sponsors - Darul Uloom Rashidia</title>
      <NavbarCustom />
      <div>
        <img
          src={Image.statsExpense}
          alt='Sponsors banner'
          className='w-full object-cover bg-bottom bg-no-repeat max-tablet:h-[200px] max-desktop:h-[300px] h-[600px]'
        />
      </div>
      {/* ================================================================= */}

      <div className='w-[100%] text-center m-auto bg-white flex flex-col items-center gap-24 max-desktop:gap-[3.75rem] max-tablet:gap-[1.875rem] max-tablet:py-[1.875rem] py-[4.125rem]'>
        <div className='font-light items-center text-xl max-desktop:w-[70%] max-tablet:w-[95%] max-desktop:text-base max-tablet:text-sm justify-center text-center'>
          <span>Narrated by Abu Huraira:</span>
          <br />
          <span>The Messenger of Allah (ﷺ) said:</span>
        </div>
        <div className='flex flex-col items-center max-desktop:w-[70%] max-tablet:w-[95%] justify-center text-center'>
          <p className='font-playfair leading-[28px] max-desktop:text-[2rem] max-tablet:text-2xl font-black text-5xl max-w-[95rem]'>
            Charity does not decrease wealth,
            <br />
            <span className='text-2xl max-desktop:text-xl max-tablet:text-lg leading-[12px] font-normal font-playfair'>
              and Allah increases the honor of a servant who forgives
            </span>
          </p>
        </div>
        <div className='font-lato font-light text-xl max-desktop:text-base max-tablet:text-sm'>
          Sahih al-Bukhari (1390)
        </div>
      </div>

      {/* ================================================================= */}

      <div
        className='w-[100%] text-center m-auto flex flex-col items-center gap-24 max-desktop:gap-[3.75rem] max-tablet:gap-[1.875rem] max-tablet:py-[1.875rem] py-[4.125rem]'
        style={{ background: colors.tertiary.gradient }}
      >
        <div className='font-light font-lateef items-center max-desktop:w-[70%] max-tablet:w-[95%] text-xl max-desktop:text-base max-tablet:text-sm justify-center text-center'>
          <p className='text-xl'>
            : ابوہریرہ رضی اللہ عنہ سے روایت ہے:
            <br /> رسول اللہ صلی اللہ علیہ وسلم نے فرمایا
          </p>
        </div>
        <div className='flex flex-col max-desktop:w-[70%] max-tablet:w-[95%] items-center justify-center text-center'>
          <p className='font-lateef leading-[28px] max-desktop:text-[2rem] max-tablet:text-2xl font-black text-5xl max-w-[95rem]'>
            ،صدقہ دینے سے مال میں کوئی کمی نہیں ہوتی <br />
            <span className='text-2xl leading-[12px] font-normal font-lateef'>
              ، اور اللہ تعالی کسی بندے کو عفو و درگزر کرنے کی بنا پر عزت میں
              اضافہ ہی فرماتا ہے۔
            </span>
          </p>
        </div>
        <div className='font-lateef font-light text-xl max-desktop:text-base max-tablet:text-sm'>
          صحیح بخاری (1390)
        </div>
      </div>

      {/* ================================================================= */}

      <div className='w-[75%] max-desktop:w-[95%] max-tablet:w-[100%] py-[6.25rem] max-tablet:py-[3.75rem] m-auto flex flex-col justify-center items-center'>
        <div className='mb-10'>
          <p className='font-extrabold font-roboto text-center text-4xl max-desktop:text-2xl max-tablet:text-xl leading-[2.625rem] uppercase tracking-tighter'>
            Current Sponsors
          </p>
          <p className='font-roboto font-normal text-2xl max-desktop:text-xl max-tablet:text-lg leading-7 text-center uppercase tracking-tight'>
            Below is the list of individuals currently sponsoring the
            Hafeez-e-Quran students.{" "}
          </p>
        </div>

        <SponsorsTable
          data={currentSponsors || []}
          length={currentLimit || 100}
        />

        <div className='mb-10 mt-20'>
          <p className='font-extrabold font-roboto text-center text-4xl max-desktop:text-2xl max-tablet:text-xl leading-[2.625rem] uppercase tracking-tighter'>
            Old Sponsors
          </p>
          <p className='font-roboto font-normal text-2xl max-desktop:text-xl max-tablet:text-lg leading-7 text-center uppercase tracking-tight'>
            Below is the list of individuals who have previously sponsored the
            Hafeez-e-Quran students.{" "}
          </p>
        </div>

        <SponsorsTable
          data={oldSponsors || []}
          length={10}
          isOld={true}
          rowCount={oldLimit}
          paginationModel={oldPaginationModel}
          onPaginationModelChange={(newModel) =>
            setOldPaginationModel(newModel)
          }
        />
      </div>

      <Footer />
    </div>
  );
};

export default Index;